import React from 'react';
import PropTypes from 'prop-types';
import newLoader from '../../../assets/lottie/12pcLoader.json';
import zillionAppLoader from '../../../assets/images/zillionAppLoader.gif';
import './Loader.scss';
import Lottie from 'lottie-react';

const style = {
	width: 100,
	justifyContent: 'center',
	display: 'flex',
};

const LoaderNew = ({ loading, loaderType = '12pc' }) => {
	return loading ? (
		<div className={loaderType === '12pc' ? 'relative' : ''}>
			<div className="loader-new-container absolute flex flex-center flex-justify-center">
				{loaderType === '12pc' ? (
					<Lottie animationData={newLoader} loop={true} style={style} />
				) : (
					<img src={zillionAppLoader} className="loaderZillion" alt="loader" />
				)}
			</div>
		</div>
	) : null;
};

LoaderNew.propTypes = {
	loading: PropTypes.bool,
};

LoaderNew.defaultProps = {
	loading: false,
};

export default LoaderNew;
